import { DataBean } from "../DataBean";

export class CostingCenterMethod extends DataBean {


   

    public async getCostingCenterMethodCatalog(idCostingCenterMethod:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingCenterMethodCatalog_Number", [idCostingCenterMethod]);
    }
}